import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Layers, PanelTop, DoorOpen, Sprout, ArrowRight, StretchHorizontal, Sofa, Forklift } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 60
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export function SolutionsPage() {
  const {
    t
  } = useLanguage();
  const solutions = [{
    id: 'smartfloor',
    title: 'SmartFloor',
    subtitle: t('home.solutions.floor.desc'),
    icon: Layers,
    desc: t('sol.floor.desc'),
    link: '/soluciones/smartfloor'
  }, {
    id: 'smartpanel',
    title: 'SmartPanel',
    subtitle: t('home.solutions.panel.desc'),
    icon: PanelTop,
    desc: t('sol.panel.desc'),
    link: '/soluciones/smartpanel'
  }, {
    id: 'smartstrips',
    title: 'SmartStrips',
    subtitle: t('home.solutions.strips.desc'),
    icon: StretchHorizontal,
    desc: t('sol.strips.desc'),
    link: '/soluciones/smartstrips'
  }, {
    id: 'smartdoor',
    title: 'SmartDoor',
    subtitle: t('home.solutions.door.desc'),
    icon: DoorOpen,
    desc: t('sol.door.desc'),
    link: '/soluciones/smartdoor'
  }, {
    id: 'smartsofa',
    title: 'SmartSofa',
    subtitle: t('home.solutions.sofa.desc'),
    icon: Sofa,
    desc: t('sol.sofa.desc'),
    link: '/soluciones/smartsofa'
  }, {
    id: 'smartmachinery',
    title: 'SmartMachinery',
    subtitle: t('home.solutions.machinery.desc'),
    icon: Forklift,
    desc: t('sol.machinery.desc'),
    link: '/soluciones/smartmachinery'
  }, {
    id: 'smartgarden',
    title: 'SmartGarden',
    subtitle: t('home.solutions.garden.desc'),
    icon: Sprout,
    desc: t('sol.garden.desc'),
    link: '/soluciones/smartgarden'
  }];
  return <div className="w-full bg-neutral-grey min-h-screen pb-32" data-id="element-937">
      {/* Header Banner */}
      <div className="relative h-[45vh] md:h-[50vh] w-full flex items-center justify-center overflow-hidden mb-20" data-id="element-938">
        <div className="absolute inset-0 z-0" data-id="element-939">
          <img src="https://cdn.magicpatterns.com/uploads/eLsX5iWTc3BRaCo3rFXREb/2_imagen_de_soluciones.png" alt="Soluciones SmartImport" className="w-full h-full object-cover" data-id="element-940" />
          <div className="absolute inset-0 bg-corporate-dark/70" data-id="element-941"></div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-942">
          <motion.h1 initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="text-5xl md:text-6xl font-heading font-bold text-white mb-6 tracking-tight" data-id="element-943">
            {t('sol.hero.title')}
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="text-xl text-gray-200 max-w-2xl mx-auto font-light" data-id="element-944">
            {t('sol.hero.desc')}
          </motion.p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-945">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-946">
          {solutions.map((sol, idx) => <motion.div key={sol.id} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} transition={{
          delay: idx * 0.15
        }} data-id="element-947">
              <Link to={sol.link} className="group flex flex-col h-full bg-white rounded-sm shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 ease-premium overflow-hidden border border-gray-100" data-id="element-948">
                <div className="p-12 flex-grow" data-id="element-949">
                  <div className="w-18 h-18 bg-neutral-grey rounded-full flex items-center justify-center mb-10 group-hover:bg-corporate-blue transition-colors duration-500 ease-premium" data-id="element-950">
                    <sol.icon className="h-9 w-9 text-corporate-blue group-hover:text-white transition-colors duration-500 ease-premium" data-id="element-951" />
                  </div>
                  <h2 className="text-4xl font-heading font-bold text-corporate-dark mb-3 tracking-tight" data-id="element-952">
                    {sol.title}
                  </h2>
                  <h3 className="text-lg text-accent-beige font-medium mb-8" data-id="element-953">
                    {sol.subtitle}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-8 font-light text-lg" data-id="element-954">
                    {sol.desc}
                  </p>
                </div>
                <div className="px-12 py-8 bg-gray-50 border-t border-gray-100 flex items-center justify-between text-corporate-blue font-medium group-hover:bg-corporate-blue group-hover:text-white transition-colors duration-500 ease-premium" data-id="element-955">
                  <span className="text-lg" data-id="element-956">{t('sol.explore')}</span>
                  <ArrowRight className="h-6 w-6 transform group-hover:translate-x-3 transition-transform duration-500 ease-premium" data-id="element-957" />
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </div>;
}